import { api } from '@/core/lib/api'
import type { TResponse } from '@/core/types/axios'
import { questionPoolEndpoints } from '@/modules/question-pool/question-pool.constants'
import type {
  TDeleteQuestionPoolResult,
  TQuestionPool,
  TQuestionPoolDetail,
  TQuestionPoolQuestion,
  TQuestionPoolOption,
  TQuestionPoolService,
  TUpdateQuestionPoolQuestionsResult,
} from '@/modules/question-pool/question-pool.types'

export const questionPoolApiService: TQuestionPoolService = {
  async list(params): Promise<TResponse<TQuestionPool[]>> {
    const response = await api.get<TResponse<TQuestionPool[]>>(
      questionPoolEndpoints.list(params)
    )
    return response.data
  },

  async options(): Promise<TQuestionPoolOption[]> {
    const response = await api.get<TResponse<TQuestionPoolOption[]>>(
      questionPoolEndpoints.options
    )
    return response.data.data
  },

  async detail(id): Promise<TQuestionPoolDetail> {
    const response = await api.get<TResponse<TQuestionPoolDetail>>(
      questionPoolEndpoints.detail(id)
    )
    return response.data.data
  },

  async getQuestionMembership(questionId): Promise<TQuestionPoolOption | null> {
    const response = await api.get<
      TResponse<{ question_pool?: TQuestionPoolOption | null }>
    >(`/admin/questions/${questionId}`)
    return response.data.data.question_pool ?? null
  },

  async listQuestions(params) {
    const response = await api.get<TResponse<TQuestionPoolQuestion[]>>(
      questionPoolEndpoints.questionList(params)
    )
    return response.data
  },

  async create(payload): Promise<TQuestionPoolDetail> {
    const response = await api.post<TResponse<TQuestionPoolDetail>>(
      questionPoolEndpoints.create,
      payload
    )
    return response.data.data
  },

  async edit(payload): Promise<TQuestionPoolDetail> {
    const { id, ...body } = payload
    const response = await api.patch<TResponse<TQuestionPoolDetail>>(
      questionPoolEndpoints.edit(id),
      body
    )
    return response.data.data
  },

  async toggleStatus(payload): Promise<TQuestionPoolDetail> {
    const response = await api.patch<TResponse<TQuestionPoolDetail>>(
      questionPoolEndpoints.status(payload.id),
      { status: payload.status }
    )
    return response.data.data
  },

  async delete(payload): Promise<TDeleteQuestionPoolResult> {
    const response = await api.delete<TResponse<TDeleteQuestionPoolResult>>(
      questionPoolEndpoints.delete(payload.id, payload.delete_questions)
    )
    return response.data.data
  },

  async updateQuestions(payload): Promise<TUpdateQuestionPoolQuestionsResult> {
    const { id, ...body } = payload
    const response = await api.patch<
      TResponse<TUpdateQuestionPoolQuestionsResult>
    >(questionPoolEndpoints.questions(id), body)
    return response.data.data
  },
}
